import { render, staticRenderFns } from "./comment_options.vue?vue&type=template&id=4b48c103&scoped=true&"
import script from "./comment_options.vue?vue&type=script&lang=js&"
export * from "./comment_options.vue?vue&type=script&lang=js&"
import style0 from "./comment_options.vue?vue&type=style&index=0&id=4b48c103&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48c103",
  null
  
)

export default component.exports